/* unplugin-vue-components disabled */import script from "./CeremonyPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CeremonyPage.vue?vue&type=script&setup=true&lang=js"

import "./CeremonyPage.vue?vue&type=style&index=0&id=262f27a7&scoped=true&lang=less"

import exportComponent from "/Users/zhangxuan/Documents/Projects/VinesDjango/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-262f27a7"]])

export default __exports__